const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8050';

export const recordAnalyticsEvent = async (eventType, metadata = {}, page = window.location.pathname) => {
  try {
    await fetch(`${API_BASE_URL}/api/v1/analytics/events`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_type: eventType,
        page,
        source: 'frontend',
        metadata,
      }),
    });
  } catch {
    // Analytics must never block learning flows.
  }
};
